import { render, staticRenderFns } from "./BaseButtonOutlined.vue?vue&type=template&id=15d9de70"
import script from "./BaseButtonOutlined.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseButtonOutlined.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports